/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Updates about Package Status received in the Isolated Zone
 * @export
 * @interface PackageStatusUpdate
 */
export interface PackageStatusUpdate {
    /**
     * 
     * @type {number}
     * @memberof PackageStatusUpdate
     */
    batchId?: number;
    /**
     * 
     * @type {Date}
     * @memberof PackageStatusUpdate
     */
    createdAt: Date;
    /**
     * Identifier of package status update
     * @type {string}
     * @memberof PackageStatusUpdate
     */
    id: string;
    /**
     * location/path of updates file
     * @type {string}
     * @memberof PackageStatusUpdate
     */
    location?: string;
    /**
     * Number of Package Status Messages contained in this update
     * @type {number}
     * @memberof PackageStatusUpdate
     */
    numberOfUpdates?: number;
    /**
     * 
     * @type {string}
     * @memberof PackageStatusUpdate
     */
    status: PackageStatusUpdateStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof PackageStatusUpdate
     */
    statusUpdatedAt: Date;
}


/**
 * @export
 */
export const PackageStatusUpdateStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type PackageStatusUpdateStatusEnum = typeof PackageStatusUpdateStatusEnum[keyof typeof PackageStatusUpdateStatusEnum];


/**
 * Check if a given object implements the PackageStatusUpdate interface.
 */
export function instanceOfPackageStatusUpdate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function PackageStatusUpdateFromJSON(json: any): PackageStatusUpdate {
    return PackageStatusUpdateFromJSONTyped(json, false);
}

export function PackageStatusUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackageStatusUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchId': !exists(json, 'batch_id') ? undefined : json['batch_id'],
        'createdAt': (new Date(json['created_at'])),
        'id': json['id'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'numberOfUpdates': !exists(json, 'number_of_updates') ? undefined : json['number_of_updates'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
    };
}

export function PackageStatusUpdateToJSON(value?: PackageStatusUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch_id': value.batchId,
        'created_at': (value.createdAt.toISOString()),
        'id': value.id,
        'location': value.location,
        'number_of_updates': value.numberOfUpdates,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
    };
}

